import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import ContentHeader from '../../components/ContentHeader';
import { BuyerAgentReport } from './Components/BuyerAgentReport';

const BuyerAgentReportPage = () => {
  useDocumentTitle('Buyer Agent Report');

  return (
    <>
      <ContentHeader title="Buyer Agent Report" />
      <BuyerAgentReport />
    </>
  );
};

export default BuyerAgentReportPage;